module.exports = __webpack_public_path__ + "img/2.bdab076d.png";